import React, { Suspense, useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonRouterOutlet, IonTabs, IonTabBar, IonTabButton, useIonRouter } from '@ionic/react'
import { Route } from 'react-router-dom'
import { modalLayer, getPlatform, useHistoryListen, useHistoryNew, setHistoryNew, setIonRoute, setDocumentTitle, miniAppRouteTo } from '@utils'
import { checkGCardCustomPageTitle, setGCardPageTitle } from '@common/utils/giftcard'
import { storeMobx } from 'restaurant'
import decorationMobx from '@mobx/app/decoration.mobx'
import themeMobx from '@mobx/app/theme.mobx'
import { permissionMobx } from '@mobx/app'
import { routerConfig } from 'common/config/routerConfig'
import { thirdConfigG } from 'controllers/third'
import { Icon, SwitchMenu, OpenScreen } from '@cps'
import { classNames, store } from '@dt/fe-utils'
import { keyBy, toInteger } from '@dt/fe-utils/dist/lodash'
import { advertMobx } from '@mobxStore'
import env from 'env'
import './index.scss'
import { WorkWeixinCanOpenBrands } from '@common/utils/hack'

const { inMiniApp, isWeixinMiniProgram, isAlipay, isWeixin, isWorkWeixin, isIOS, isAliPayMiniProgram } = getPlatform()
const routerList = []
const routerNameMap = {}
const getPathStatic = (path: string) => path.replace(/\/:\S*$/, '')
const getPathName = (path: string) => {
  if (!path) {
    return ''
  } else if (routerNameMap[path]) {
    return routerNameMap[path]
  } else {
    return getPathName(path.split('/').slice(0, -1).join('/'))
  }
}
routerConfig.forEach(({ path, pageName, component: Component, children }) => {
  routerNameMap[getPathStatic(path)] = pageName
  routerList.push(
    <Route
      key={path}
      exact
      path={path}
      render={(props: any) => (
        <>
          <Component
            {...props}
            pageName={i18n.t(pageName)}
          />
        </>
      )}
    />
  )
  if (children?.length) {
    children.forEach((child) => {
      const childPath = `${path}/${child.path}`
      routerNameMap[getPathStatic(childPath)] = child.pageName
      routerList.push(
        <Route
          key={childPath}
          exact
          path={childPath}
          render={(props: any) => (
            <>
              <child.component
                {...props}
                pageName={i18n.t(pageName)}
              />
            </>
          )}
        />
      )
    })
  }
})

// TODO 找一个更好的监听方式， 现在是利用事件触发比history的监听触发更快的方式做的
let changeTabFlag = false
let ionRouter: any

const Dashboard: React.FC = () => {
  const [showTabBar, setShowTabBar] = useState(true)
  const [animated, setAnimated] = useState(true)
  const [pathname, setPathname] = useState('')
  const history = useHistoryNew()
  const {} = permissionMobx
  const isNotShowTabs = Config.buyTogetherId || Config.isPreOrder
  setHistoryNew(history)
  ionRouter = useIonRouter()
  if (window.MX) {
    window.MX.ionRoute = ionRouter
    window.MX.history = history
  }
  setIonRoute(useIonRouter())

  const getShowOpenScreen = useMemo(() => {
    const matchs = document.location.pathname.match(/^\/([^/]*)\/?/)
    const pathState = matchs ? matchs[1] : ''
    const showOpenScreen = (!pathState || ['home', 'menu'].includes(pathState)) && !inMiniApp && !isWeixinMiniProgram && !isAliPayMiniProgram && localStorage.getItem(`ls.needOpenScreen.${Config.BRANDID}`) !== 'false'
    localStorage.removeItem(`ls.needOpenScreen.${Config.BRANDID}`)
    return showOpenScreen
  }, [inMiniApp, isWeixinMiniProgram, isAliPayMiniProgram])

  // 监听touch
  if (isIOS) {
    let startX: number, startY: number, moveX: number, moveY: number = 0
    document.addEventListener('touchstart', function (e) {
      startX = e?.targetTouches?.[0]?.pageX
      startY = e?.targetTouches?.[0]?.pageY
    })
    document.addEventListener('touchmove', function (e) {
      moveX = e?.targetTouches?.[0]?.pageX
      moveY = e?.targetTouches?.[0]?.pageY
    }, { passive: false })
    document.addEventListener('touchend', function (e) {
      if (Math.abs(moveX - startX) > Math.abs(moveY - startY)) {
        setAnimated(false)
      } else {
        !animated && setAnimated(true)
      }
    })
  }

  // 监听路由变化
  useHistoryListen((pathname: string) => {
    console.log(pathname, 'pathname')
    if (Config.codeType === 'brand') {
      if (['/home', '/orders', '/my', '/mall'].includes(pathname)) {
        themeMobx.setTemplateAdvert(storeMobx.brand, true)
      } else {
        if (themeMobx.storeTemplateAdvert) {
          const manualSwitch = true
          themeMobx.setTemplateAdvert({ ...themeMobx.storeTemplateAdvert }, manualSwitch, storeMobx.info)
        }
      }
    } else {
      if (themeMobx.storeTemplateAdvert) {
        themeMobx.setTemplateAdvert({ ...themeMobx.storeTemplateAdvert }, true, storeMobx.info)
      }
    }
    const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
    const tabMap = keyBy(themeMobx.showTabs, 'href')
    const pathInTab = ['/home', '/menu', '/orders', '/my', '/giftCard', '/mall'].filter(key => tabMap[key]).includes(pathname)
    const hasTabMap = keyBy(themeMobx.showTabsPages, 'href')
    const pathHasTab = ['/home', '/menu', '/orders', '/my', '/giftCard', '/mall'].filter(key => hasTabMap[key]).includes(pathname)
    /** 商城授权过期 */
    const isMalllExpire = permissionMobx.getCheckMallExpire
    modalLayer.closeAll()
    setPathname(pathname)
    decorationMobx.setPathName(pathname)
    if (checkGCardCustomPageTitle()) {
      setGCardPageTitle() // 礼品卡自定义页面标题
    } else if (['/recommend'].includes(pathname)) {
      setDocumentTitle(i18n.t('advert.recommend'))
    } else if (!['/advert', '/advertBrand'].includes(pathname)) {
      setDocumentTitle(pathInTab && tabMap?.[pathname] ? (tabMap?.[pathname]?.name || i18n.t(`entry.${tabMap?.[pathname]?.type}`)) : i18n.t(getPathName(pathname)))
    } else {
      setDocumentTitle(advertMobx?.adDetail?.adTitle || i18n.t('advert.recommend'))
    }

    // 路由变化清空上一次的小程序分享信息
    thirdConfigG()?.postMessage({
      type: 'shareInfo',
      shareInfo: null
    })
    // cn非微信打开
    if ((!isWeixin || isWorkWeixin) && !isAlipay && bo === 'cn' && !window?.cordova && process.env.NODE_ENV !== 'development' && pathname === '/menu' && !store.get('cn.openbrower') && env.env !== 'test') {
      if (!WorkWeixinCanOpenBrands.includes(toInteger(Config.BRANDID))) {
        history.replace('/notWeixin')
        return
      }
    }
    // 小程序返回
    const matchs = document.location.pathname.match(/^\/([^/]*)\/?/)
    const pathState = matchs ? matchs[1] : ''
    if ((isWeixinMiniProgram || isAliPayMiniProgram) && !ionRouter.canGoBack() && ionRouter.routeInfo.routeDirection === 'none' && !['/checkout', '/store'].includes(ionRouter.routeInfo.pathname) && ['/pay'].includes(pathState)) {
      if (hasHome && hasHome.isShow !== 0) {
        if (isWeixinMiniProgram || isAliPayMiniProgram) {
          miniAppRouteTo('/pages/home/index')
          return
        }
      }
    }
    if (pathInTab) {
      if (['/home'].includes(pathname)) {
        if (hasHome && hasHome.isShow !== 0) {
          if (isWeixinMiniProgram || isAliPayMiniProgram) {
            miniAppRouteTo('/pages/home/index')
            return
          }
        }
      }
    }
    if (pathHasTab) {
      if (isNotShowTabs) {
        setShowTabBar(false)
        decorationMobx.setTabBarVisible(false)
      } else {
        setShowTabBar(true)
        decorationMobx.setTabBarVisible(true)
        document.querySelector('ion-tab-bar')?.classList.remove('hide')
      }
    } else {
      setShowTabBar(false)
      decorationMobx.setTabBarVisible(false)
    }
    if (changeTabFlag) {
      changeTabFlag = false
      // history.setHistoryList([pathname])
      window.history.replaceState(window.history.state, '', pathname + themeMobx.urlSearch)
    }
    if (isMalllExpire && ['mproduct', 'mcollect', 'mall'].includes(pathState)) {
      history.replace('/noMall')
    }
  })

  useEffect(() => {
    // const pathname = window.location.pathname
    if (themeMobx.storeTemplateAdvert?.storeTemplateContent?.length) {
      const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
      const tabMap = keyBy(themeMobx.showTabs, 'href')
      const pathInTab = ['/home', '/menu', '/orders', '/my', '/giftCard', '/mall'].filter(key => tabMap[key]).includes(pathname)
      const hasTabMap = keyBy(themeMobx.showTabsPages, 'href')
      const pathHasTab = ['/home', '/menu', '/orders', '/my', '/giftCard', '/mall'].filter(key => hasTabMap[key]).includes(pathname)
      if (pathInTab) {
        if (['/home'].includes(pathname)) {
          if (hasHome && hasHome.isShow !== 0) {
            if (isWeixinMiniProgram || isAliPayMiniProgram) {
              miniAppRouteTo('/pages/home/index')
              return
            }
          }
        }
      }
      if (pathHasTab) {
        if (isNotShowTabs) {
          setShowTabBar(false)
          decorationMobx.setTabBarVisible(false)
        } else {
          setShowTabBar(true)
          decorationMobx.setTabBarVisible(true)
          document.querySelector('ion-tab-bar')?.classList.remove('hide')
        }
      } else {
        setShowTabBar(false)
        decorationMobx.setTabBarVisible(false)
      }
    }
  }, [themeMobx.storeTemplateAdvert, pathname])

  return (
    <Suspense fallback={null}>
      <IonTabs onIonTabsDidChange={() => {
        changeTabFlag = true
      }}
      >
        <IonRouterOutlet animated={animated}>
          {routerList}
        </IonRouterOutlet>
        <IonTabBar
          slot='bottom'
          className={classNames('handtop-tabbar', { 'tabbar-float': themeMobx?.data?.tabBar?.enablePosition !== 1, 'has-fullofbar': decorationMobx.fullOfBarAndTabBar })}
          style={{
            '--ion-background-sec': themeMobx?.data?.tabBar?.backgroundColor,
            display: showTabBar ? 'flex' : 'none'
          }}
        >
          {
            themeMobx.showTabs.map(({ type, name, mode, href, icon, pic, activePic }) => {
              let realIcon = icon.indexOf('tab') <= -1 ? `tab-${icon}` : icon
              return (
                <IonTabButton
                  key={type}
                  tab={type}
                  href={href}
                  className={` tabbar-item ${href === pathname ? 'selected' : ''}`}
                  style={themeMobx?.data?.tabBar?.enableName ? { color: href === pathname ? themeMobx?.data?.tabBar?.selectedFontColor : themeMobx?.data?.tabBar?.unSelectedFontColor } : {}}
                >
                  {
                    mode === 1
                      ? (<img src={pathname === href ? activePic : pic} />)
                      : <Icon icon='dicon' name={href === pathname ? `${realIcon}_active` : realIcon} />
                  }
                  {themeMobx.data.tabBar.enableName ? (<label>{name || i18n.t(`entry.${type}`)}</label>) : null}
                </IonTabButton>
              )
            })
          }
        </IonTabBar>
      </IonTabs>
      {/* 菜单切换 需要在多个路由中都显示 */}
      <SwitchMenu />
      <OpenScreen isShow={getShowOpenScreen} />
    </Suspense>
  )
}

export default observer(Dashboard)
